import React from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import maintenance from '../assets/maintenance.json';
import LogoImg from '../assets/logo.svg';

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff200;
  padding: 20px;
  text-align: center;
`;

const Content = styled.div`
  background-color: white;
  width: 100%;
  max-width: 600px;
  border-radius: 20px;
  padding: 40px;
  margin-top: 20px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LottieContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 20px 0;
`;

const MainText = styled.h1`
  font-size: 28px;
  line-height: 32px;
  font-weight: 600;
  color: #2c2c2c;
  margin: 20px 0;
`;

const Subtext = styled.p`
  font-size: 18px;
  line-height: 24px;
  color: #666;
  margin: 20px 0;
`;

const Logo = styled.img`
  width: 60%;
  max-width: 220px;
  height: auto;
  margin-bottom: -30px;
  margin-top: -10px;
  cursor: pointer;
`;

const Maintenance = () => {
  return (
    <Wrapper>
      <Logo src={LogoImg} alt="Prestix" />
      <Content>
        <LottieContainer>
          <Lottie animationData={maintenance} style={{ width: '200px' }} />
        </LottieContainer>
        <MainText>Estamos trabajando</MainText>
        <Subtext>
          Nuestro sitio está en mantenimiento para brindarte una mejor experiencia.
          <br /><br />
          Volveremos en breve.
        </Subtext>
      </Content>
    </Wrapper>
  );
};

export default Maintenance; 